var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinBrands1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.22,
    height: 50.22,
    fill: "white",
    transform: "translate(0.560059 0.649902)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBrands1);
export default __webpack_public_path__ + "static/media/linkedin-brands 1.dbf6d1b8f3bcc54a844f907b9ba98877.svg";
export { ForwardRef as ReactComponent };